// Settings

import $ from 'jquery'
window.$ = window.jQuery = $

import validate from 'jquery-validation'
window.validate = window.validator = $

import Swal from 'sweetalert2'
window.Swal = Swal

// Globals

import '../elements/_partials/menu.js'
import '../elements/_partials/cookie-consent.js'
import '../elements/_partials/scroll-down.js'
import '../elements/_partials/scroll-to-top.js'
import '../elements/_partials/promo-line-rotation.js'
import '../elements/_partials/show-more.js'
import '../elements/_partials/modal.js'

// Page specified scripts

import '../elements/forms/page-proxmox.js'
import '../elements/accordion/accordion.js'

// Unused scripts

// import '../elements/forms/newsletter-form.js'

// WIP scripts
